import { ReactElement } from "react";
import { Dialog } from "../../../Components/Dialog/Dialog";
import { FormattedText } from "../../../Components/FormattedText/FormattedText";
import { Toolbar } from "../../../Components/Toolbar/Toolbar";
import { Anchor } from "../../../Components/Anchor/Anchor";
import { localize } from "client_legacy/ndaw/culture";
import { renderReactDialog } from "../../../Components/DialogRenderer/DialogRenderer";
import styles from "./ExternalUrlConfirmationDialog.module.less";

export type ExternalUrlConfirmationDialogProps = {
	url: string;
	onClose: () => void;
};

export const ExternalUrlConfirmationDialog = (
	props: ExternalUrlConfirmationDialogProps
): ReactElement => {
	const {
		url,
		onClose
	} = props;

	return (
		<Dialog trackingId="external-url-confirmation-dialog">
			<Dialog.Header
				title={localize("_YouAreLeavingTheWorkspace")}
			/>
			<Dialog.Body>
				<div className={styles.content}>
					<FormattedText
						text={localize("_IfYouTrustThisLinkClickItToContinue")}
						thingsToReplace={[
							{
								what: "{{Link}}",
								filler: (
									<Anchor
										href={url}
										target="_blank"
										onClick={onClose}
									>
										{url}
									</Anchor>
								)
							}
						]}
					/>
				</div>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Close")}
						onClick={onClose}
						trackingId="close"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};

ExternalUrlConfirmationDialog.displayName = "ExternalUrlConfirmationDialog";

export function openExternalUrlConfirmationDialog(
	url: string
): void {
	return renderReactDialog(
		(onClose): ReactElement => (
			<ExternalUrlConfirmationDialog
				url={url}
				onClose={onClose}
			/>
		)
	);
}
